import * as yup from "yup";

export const validations = {
  B100: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  B50: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  B20: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  B10: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  B5: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  B1: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  M100: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  M50: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  M25: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  M10: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  M5: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
  M1: yup
    .number()
    .min(0, "Ingrese un valor mayor o igual a 0")
    .integer("Ingrese un valor entero")
    .required("Campo requerido"),
};